import { Navigate } from "react-router-dom";

// Create Agent is now a slide-in panel on /agents.
// This redirect handles any bookmarked or shared /agents/new URLs.
export function AgentCreate() {
  return <Navigate to="/agents" replace />;
}
